import { Directive, effect, ElementRef, Renderer2, inject } from '@angular/core';
import { I18nService } from './i18n.service';
import { Language } from './languages.model';

@Directive({
  selector: '[gnxRtl]',
  exportAs: 'gnxRtl',
  standalone: true,
})
export class RtlDirective {
  private renderer = inject(Renderer2);
  private el = inject(ElementRef);
  private i18n = inject(I18nService);

  lang: Language;

  constructor() {
    effect(() => {
      this.lang = I18nService.language();
      if (this.lang) {
        if (this.lang.key === 'hb') {
          this.renderer.setAttribute(this.el.nativeElement, 'dir', 'rtl');
        } else {
          this.renderer.setAttribute(this.el.nativeElement, 'dir', 'ltr');
        }
      }
    });
  }

  getLocaleKey() {
    return this.lang?.dateLocaleKey || 'en-US';
  }
}
